import React from "react"
import styled from "styled-components"
import {
  Card,
  SectionTitle,
  CardV2,
  Badge,
  CLOUDFRONT,
  StatusText,
  StatusDiv,
  BadgeText,
  StatusMessage,
} from "../commonStyles"

const ComponentWrap = styled.div``

//2E7D32

const Ready = () => (
  <ComponentWrap>
    <CardV2
      cardWidth="800px"
    >
      <StatusText>
        Status of the ICA
      </StatusText>
      <StatusDiv>
        <Badge
          bgColor="#2E7D32"
        >
          <img src="https://s3.amazonaws.com/cdn.agentdesks.com/images/ISA_ASSETS/SOUL_ISA_THUMBSUP.svg" alt="soul_asset" />
          <BadgeText>Ready to send</BadgeText>
        </Badge>
        <StatusMessage>
          You have signed the document. Now lets send it to the agent for signature.
        </StatusMessage>
      </StatusDiv>
    </CardV2>
  </ComponentWrap>
)

export default Ready
